export * from './communication-modal/communication-modal.component';
